import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import bootstrapcss from './assets/bootstrap/css/bootstrap.min.css'
import bootstrapjs from './assets/bootstrap/js/bootstrap.bundle'
import "swiper/swiper.min.css"

// 使用 vue-meta
import Meta from "vue-meta";
Vue.use(Meta);

Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

new Vue({
  router,
  store,
  bootstrapcss,
  bootstrapjs,
  render: h => h(App)
}).$mount('#app')
